export function joinPath(parent: string, child: string): string {
  if (parent === '/' || parent === '') {
    return ensureLeadingSlash(child)
  }
  return `${stripTrailingSlash(parent)}${ensureLeadingSlash(child)}`
}

function ensureLeadingSlash(value: string): string {
  if (!value) {
    return value
  }
  return value.startsWith('/') ? value : `/${value}`
}

function stripTrailingSlash(value: string): string {
  return value.length > 1 ? value.replace(/\/+$/, '') : value
}
